export default __webpack_public_path__ + "static/media/logoNBS.a7b8d734.svg";